import ReactDOM from 'react-dom';
import Card from './Card';
import Button from './Button';
import { Icon } from '@mui/material';

import './NotificationModal.scss';

const NotificationModal = (props) => {
	const Backdrop = (props) => {
		return (
			<div
				className='notification-backdrop'
				onClick={props.onConfirm}
			/>
		);
	};
	const ModalOverlay = (props) => {
		return (
			<Card className='notification-modal'>
				<div className='modal-controls'>
					{props.status === 'success' ? (
						<Icon className='modal-control-icon-success'>
							done
						</Icon>
					) : (
						<Icon className='modal-control-icon-error'>
							close
						</Icon>
					)}
					<section>
						<header>
							<h3 className='modal-title'>
								{props.title}
							</h3>
						</header>
					</section>
					<div className='modal-subtitle'>
						<p>{props.message}</p>
					</div>
					<footer>
						<Button
							onClick={props.onConfirm}
							className='primary-button'
						>
							Close
						</Button>
					</footer>
				</div>
			</Card>
		);
	};

	return (
		<>
			{ReactDOM.createPortal(
				<Backdrop onConfirm={props.onConfirm} />,
				document.getElementById('backdrop-root')
			)}
			{ReactDOM.createPortal(
				<ModalOverlay
					title={props.title}
					message={props.message}
					onConfirm={props.onConfirm}
					status={props.status}
				/>,
				document.getElementById('overlay-root')
			)}
		</>
	);
};

export default NotificationModal;
